import { SVG } from '../../SVG'

const GenericLogoCollapsed = ({ style = {}, ...props }) => (
  <SVG
    width='56'
    height='55'
    viewBox='0 0 56 55'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'var(--primary-color)', ...style }}
    {...props}
  >
    <path d='M31.653 26.1394L31.5806 55L10.398 42.1768L10.0503 16.5449L31.653 26.1394Z' fill='#2C3B63' />
    <path d='M34.1357 26.1296L34.213 54.995L55.3956 42.167L55.7433 16.5352L34.1357 26.1296Z' fill='#2C3B63' />
    <path d='M10.5864 14.0025L32.7446 23.8917L54.9027 14.0025L32.7446 4.58203L10.5864 14.0025Z' fill='#347BE2' />
    <path d='M6.64551 9.64292L14.228 13.0263L21.8104 9.64292L14.228 6.42383L6.64551 9.64292Z' fill='#347BE2' />
    <path d='M6.78076 3.22392L14.3632 6.60735L21.9457 3.22392L14.3632 0L6.78076 3.22392Z' fill='#347BE2' />
    <path d='M21.5688 3.22345L26.553 5.44685L31.5371 3.22345L26.553 1.10156L21.5688 3.22345Z' fill='#347BE2' />
    <path d='M0 3.37331L3.76225 5.05536L7.52449 3.37331L3.76225 1.77344L0 3.37331Z' fill='#347BE2' />
  </SVG>
)

export default GenericLogoCollapsed
